import React, { useEffect, useState } from 'react';
import { usePaginacion, Paginacion, PiePagina, uuidv4, Axios } from '../../../Helpers/importacionesComunes'
import { } from '@fortawesome/free-regular-svg-icons';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { useContextoGlobal } from '../../../Context/contextoGlobal'
import Excel from '../../../componentes/Excel'
import { Card, CardBody,Button, Typography } from '@material-tailwind/react';
import { ChevronUpDownIcon, PencilSquareIcon, PrinterIcon } from '@heroicons/react/24/solid';
import { useHistory } from "react-router-dom";
import { formatearMontoMoneda } from '../../../Helpers/utilidades-globales';
import moment from 'moment';

const getFechaTimestamp = (value) => {
    if (!value) {
        return 0
    }

    const parsedDate = moment(value)
    return parsedDate.isValid() ? parsedDate.valueOf() : 0
}

const ordenarPorFechaDesc = (registros = []) => {
    return [...registros].sort((a, b) => getFechaTimestamp(b.fecha) - getFechaTimestamp(a.fecha))
}

const columnas = [
    { label: 'Fecha', value: 'fecha' },
    { label: 'Proveedor', value: 'proveedor' },
    { label: 'Comprobante', value: 'comprobante'},
    { label: 'Forma Pago', value: 'fp' },
    { label: 'Rubro', value: 'rubro' },
    { label: 'Fondo', value: 'fondo' },
    { label: 'Caja', value: 'caja' },
    { label: 'Total', value: 'monto' },
]

export const Tabla = ({ registrosAmostrar, cleanUpData }) => {

    const { configuracion, paginar, inicializar: inicializarPaginacion } = usePaginacion()
    // Hago una copia de los datos que se reciben para manejar el ordenamiento
    const [copiaRegistrosaMostrar, setCopiaRegistrosaMostrar] = useState([...registrosAmostrar])
    const [orden, setOrden] = useState(null)
    const [nuevoCampo, setNuevoCampo] = useState(true)
    const [contadorOrden, setContadorOrden] = useState(0)
    const [rubros, setRubros] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const { usuario } = useContextoGlobal()
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(!open);
    const history = useHistory();

    useEffect(() => {
        const registrosOrdenados = ordenarPorFechaDesc(registrosAmostrar)
        setCopiaRegistrosaMostrar(registrosOrdenados)
        inicializarPaginacion(null, registrosOrdenados)
    }, [registrosAmostrar])


    useEffect(() => {// el ordenamiento se maneja con las propiedades orden que almacena el campo por el cual ordenar
        // y nuevoCampo que es un flag que indica si es otro campo o el mismo a la inversa
        // cada vez que se cambia el orden en click de la cabecera se cambia contadorOrden como un trigger 

        ordenarDatos()
    }, [contadorOrden])

    const ordenarDatos = () => {
        setCopiaRegistrosaMostrar([...copiaRegistrosaMostrar].sort((a, b) => { return comparacion(a, b) }))
    }

    const funcionOrden = (nombre_campo) => {

        if (orden == nombre_campo) {
            setNuevoCampo(false)
        } else {
            setNuevoCampo(true)
        }

        setOrden(nombre_campo)
        setContadorOrden(contadorOrden + 1)

    }

    const comparacion = (a, b) => {

        switch (orden) {
            case null: return 0
            case 'id_region':
            case 'edad':

                if (nuevoCampo == true) {
                    return a[orden] - b[orden]
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden] - a[orden]
                    } else {
                        return a[orden] - b[orden]
                    }
                }
            case 'ult_ascenso':
            case 'fecha':
                const fa = getFechaTimestamp(a[orden])
                const fb = getFechaTimestamp(b[orden])

                if (nuevoCampo == true) {
                    return fa - fb
                } else {
                    if (contadorOrden % 2 == 0) {
                        return fb - fa
                    } else {
                        return fa - fb
                    }
                }
            default:
                if (nuevoCampo == true) {
                    return a[orden].localeCompare(b[orden])
                } else {
                    if (contadorOrden % 2 == 0) {
                        return b[orden].localeCompare(a[orden])
                    } else {
                        return a[orden].localeCompare(b[orden])
                    }
                }
        }
    }

    const convertirFormato = (numero) => {
        let numeroConPunto = numero.replace(/,/g, '.');
        let numeroEnNuevoFormato = numeroConPunto.replace(/\.(?=[^.]*$)/, ',');
        return numeroEnNuevoFormato;
    }

    const truncateText = (text, maxLength) => {
        if (text.length > maxLength) {
            return text.substring(0, maxLength);
        }
        return text;
    };

    const editarEgreso = (id_egreso) => {
        localStorage.setItem('egresoId', JSON.stringify({ id_egreso }));
        history.push({
            pathname: '/egreso/editar',
            state: { fromEgresosSearch: true },
        });
    }

    const reimprimirEgreso = (id_egreso) => {
        localStorage.setItem('egresoId', JSON.stringify({ id_egreso }));
        history.push({
            pathname: '/egreso/detalle',
            state: { fromEgresosSearch: true },
        });
    }

    return <div className="mt-2 mx-5">

        {copiaRegistrosaMostrar.length > 0 && <Excel datos={copiaRegistrosaMostrar}
            descripcion='Movimientos'
            columnas={columnas}
            titulo='Ingresos' />}
        <Button className="mt-2 w-48 flex justify-center mb-4 bg-gray-900" onClick={cleanUpData}>
            Regresar 
        </Button>
        
        {copiaRegistrosaMostrar.length > 0 &&
            <Card className="h-full w-full rounded-none">
                <CardBody className="overflow-scroll-none px-0 pt-0 pb-0">
                    <table className="table-auto text-left w-full">
                        <thead>
                            <tr>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Fecha' sort orden={orden === 'fecha'} callback={() => funcionOrden('fecha')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Proveedor' sort orden={orden === 'proveedor'} callback={() => funcionOrden('proveedor')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Comprobante' sort orden={orden === 'titular'} callback={() => funcionOrden('comprobante')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Forma Pago' sort orden={orden === 'fp'} callback={() => funcionOrden('fp')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Rubro' sort orden={orden === 'rubro'} callback={() => funcionOrden('rubro')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Fondo' sort orden={orden === 'contribuyente'} callback={() => funcionOrden('fondo')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Caja' sort orden={orden === 'domicilio'} callback={() => funcionOrden('caja')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Total' sort orden={orden === 'provincia'} callback={() => funcionOrden('monto')} />
                                </th>
                                <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                                    <ThTitle title='Acciones' sort orden={orden === 'acciones'} callback={() => {}} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {copiaRegistrosaMostrar
                                .filter((item, index) => {
                                    return index >= configuracion.iIni && index <= configuracion.iFin
                                })
                                .map(
                                    (item, index) => {
                                        const isLast = index === copiaRegistrosaMostrar.length - 1;
                                        const classes = isLast
                                            ? "p-4"
                                            : "p-4 border-b border-blue-gray-50";

                                        return (
                                            <>
                                                <tr key={uuidv4()}>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal opacity-70 text-center"
                                                        >
                                                            {moment(item.fecha).format('DD/MM/YYYY')}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-left"
                                                        >
                                                            {item.proveedor ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-left"
                                                        >
                                                            {item.comprobante ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <ValueChip value={item.fp} />
                                                    </td>
                                                    <td className={classes}>
                                                        <ValueChip value={item.rubro} />
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-center"
                                                        >
                                                            {item.fondo ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={`${classes}`}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-center"
                                                        >
                                                            {item.caja ?? '--'}
                                                        </Typography>
                                                    </td>
                                                    <td className={classes}>
                                                        <Typography
                                                            variant="small"
                                                            color="blue-gray"
                                                            className="font-normal text-right"
                                                        >
                                                            {formatearMontoMoneda(item.monto)}
                                                        </Typography>
                                                    </td>

                                                    <td className={classes}>
                                                        <div className="flex items-center justify-center gap-2">
                                                            <span
                                                                onClick={() => reimprimirEgreso(item.id_egreso)}
                                                                title="Reimprimir minuta"
                                                                className="cursor-pointer text-blue-gray-500 hover:text-blue-gray-700 transition-colors"
                                                            >
                                                                <PrinterIcon className="h-6 w-6" />
                                                            </span>
                                                            <span
                                                                onClick={() => editarEgreso(item.id_egreso)}
                                                                title="Editar el egreso"
                                                                className="cursor-pointer text-blue-gray-500 hover:text-blue-gray-700 transition-colors"
                                                            >
                                                                <PencilSquareIcon className="h-6 w-6" />
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>

                                        );

                                    }
                                )}
                        </tbody>
                    </table>

                    {copiaRegistrosaMostrar.length > 0 &&
                        <PiePagina>
                            <div className="items-center">
                                <Paginacion configuracion={configuracion} paginar={paginar} />
                            </div>
                        </PiePagina>}
                </CardBody>
            </Card>
        }
    </div>
}


const ThTitle = ({ title, sort, orden, callback }) => {
    return <div className='flex f-col justify-center items-center'>
        <Typography
            variant="small"
            color="blue-gray"
            className="flex justify-between gap-2 font-normal leading-none opacity-70"
        >
            {title}{" "}
            {sort &&
                <ChevronUpDownIcon strokeWidth={2} className={`cursor-pointer ${orden ? 'text-blue-500' : ''} h-4 w-4`} icon={faSort} onClick={callback} />
            }
        </Typography>
    </div>
}

const ValueChip = ({ value }) => {
    const hasValue = Boolean(value);

    return (
        <span
            className={[
                'inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold shadow-sm',
                hasValue
                    ? 'border-cyan-100 bg-cyan-50 text-cyan-700'
                    : 'border-blue-gray-100 bg-blue-gray-50 text-blue-gray-500'
            ].join(' ')}
        >
            {hasValue ? value : '--'}
        </span>
    );
};